import { Recipient } from './recipient';

export interface ScanConfig {
  id: string;
  name: string;
  runnerId: string;
  lastResultStatus: LastResultStatus;
  lastResultInfo: string | undefined;
  recipients: Recipient[];
  runWeekly: boolean;
  nextRunTime: Date;
  internalScansEnabled: boolean;
  externalScansEnabled: boolean;
  websiteScansEnabled: boolean;
  darknetScansEnabled: boolean;
  scanIntervalInWeeks: number;
  availableActions: string[];
}

export enum LastResultStatus {
  NONE = 'NONE',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}
